export const GET_ACCESS_ARRANGEMENT_REQUEST = 'GET_ACCESS_ARRANGEMENT_REQUEST';
export const DELETE_ACCESS_ARRANGEMENT_REQUEST = 'DELETE_ACCESS_ARRANGEMENT_REQUEST';
export const POST_ACCESS_ARRANGEMENT_POST_DRAFT_APPLICATION =
  'POST_ACCESS_ARRANGEMENT_POST_DRAFT_APPLICATION';
export const POST_ACCESS_ARRANGEMENT_NEW_APPLICATION = 'POST_ACCESS_ARRANGEMENT_NEW_APPLICATION';
export const GET_ACCESS_ARRANGEMENT_MEDICAL_CONDITIONS =
  'GET_ACCESS_ARRANGEMENT_MEDICAL_CONDITIONS';
export const GET_ACCESS_ARRANGEMENT_SELECTED_CONDITIONS =
  'GET_ACCESS_ARRANGEMENT_SELECTED_CONDITIONS';
export const GET_ACCESS_ARRANGEMENT_SUBMITTED_DRAFT = 'GET_ACCESS_ARRANGEMENT_SUBMITTED_DRAFT';
export const POST_ACCESS_ARRANGEMENT_MODIFY_SELECTED_MEDICAL_CONDITIONS =
  'POST_ACCESS_ARRANGEMENT_MODIFY_SELECTED_MEDICAL_CONDITIONS';
export const GET_ACCESS_ARRANGEMENT_REQUEST_DETAILS = 'GET_ACCESS_ARRANGEMENT_REQUEST_DETAILS';
export const GET_ACCESS_ARRANGEMENT_DRAFT_DATE_TIME = 'GET_ACCESS_ARRANGEMENT_DRAFT_DATE_TIME';
export const POST_ACCESS_ARRANGEMENT_REQUEST_DETAILS = 'POST_ACCESS_ARRANGEMENT_REQUEST_DETAILS';
export const PUT_ACCESS_ARRANGEMENT_REQUEST_DETAILS = 'PUT_ACCESS_ARRANGEMENT_REQUEST_DETAILS';
export const DELETE_ACCESS_ARRANGEMENT_REQUEST_DETAILS =
  'DELETE_ACCESS_ARRANGEMENT_REQUEST_DETAILS';
export const POST_ACCESS_ARRANGEMENT_UPLOAD_DOCUMENTS = 'POST_ACCESS_ARRANGEMENT_UPLOAD_DOCUMENTS';
export const GET_ACCESS_ARRANGEMENT_UPLOAD_DOCUMENTS_STATUS =
  'GET_ACCESS_ARRANGEMENT_UPLOAD_DOCUMENTS_STATUS';
export const GET_ACCESS_ARRANGEMENT_REVIEW_DETAILS = 'GET_ACCESS_ARRANGEMENT_REVIEW_DETAILS';
export const PUT_ACCESS_ARRANGEMENT_UPDATE_DRAFT = 'PUT_ACCESS_ARRANGEMENT_UPDATE_DRAFT';
export const GET_ACCESS_ARRANGEMENT_REQUEST_ACKNOWLEDGEMENT =
  'GET_ACCESS_ARRANGEMENT_REQUEST_ACKNOWLEDGEMENT';
export const GET_ACCESS_ARRANGEMENT_SUMMARY = 'GET_ACCESS_ARRANGEMENT_SUMMARY';
export const GET_ACCESS_ARRANGEMENT_DOWNLOAD_PDF = 'GET_ACCESS_ARRANGEMENT_DOWNLOAD_PDF';
export const DELETE_ACCESS_ARRANGEMENT_FILE = 'DELETE_ACCESS_ARRANGEMENT_FILE';
export const GET_MEDICAL_CONDITIONS_AMENDMENT = 'GET_MEDICAL_CONDITIONS_AMENDMENT';
export const GET_ACCESS_ARRANGEMENT_MEDICAL_CONDITIONS_AMENDMENT =
  'GET_ACCESS_ARRANGEMENT_MEDICAL_CONDITIONS_AMENDMENT';
export const GET_ACCESS_ARRANGEMENT_REVIEW_DETAILS_AMENDMENT =
  'GET_ACCESS_ARRANGEMENT_REVIEW_DETAILS_AMENDMENT';
export const GET_ACCESS_ARRANGEMENT_INDIVIDUAL_REPORT_FILES =
  'GET_ACCESS_ARRANGEMENT_INDIVIDUAL_REPORT_FILES';
export const GET_ACCESS_ARRANGEMENT_INDIVIDUAL_REPORT_SUBMITTED_FILES =
  'GET_ACCESS_ARRANGEMENT_INDIVIDUAL_REPORT_SUBMITTED_FILES';
